import { GridValueFormatterParams } from '@mui/x-data-grid-pro'
import { store } from '@user/store/store'
import { selectBranchById } from '@user/store/branches/slice'

export const branchValueFormatter = ({
  value,
}: GridValueFormatterParams): any =>
  typeof value === 'string'
    ? selectBranchById(store.getState(), value)?.name ?? ''
    : ''
